import { createInjectionKey } from "../../_utils/vue/create-injection-key.mjs";
export const modalBodyInjectionKey = createInjectionKey('n-modal-body');
export const modalProviderInjectionKey = createInjectionKey('n-modal-provider');
export const modalInjectionKey = createInjectionKey('n-modal');